import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['selector', 'display'];

  showFilename() {
    this.displayTarget.innerHTML = this.selectorTarget.value.replace(/^.*\\/, '');
  }
}
